import { useI18n } from '../../lib/i18n';
import { AlertTriangleIcon } from '../icons';
import { Button } from '../ui/Button';

export interface TokenExpiryBannerProps {
  expiringCount: number;
  onReconnect: () => void;
}

export function TokenExpiryBanner({ expiringCount, onReconnect }: TokenExpiryBannerProps) {
  const { t } = useI18n();

  if (expiringCount <= 0) return null;

  return (
    <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3 rounded-card border border-warning-200 bg-warning-50/80 p-4 text-warning-900 shadow-sm dark:border-amber-900/60 dark:bg-amber-950/40 dark:text-amber-200">
      <div className="flex items-start gap-3">
        <span className="mt-0.5 grid h-8 w-8 shrink-0 place-items-center rounded-lg bg-warning-100 text-warning dark:bg-amber-900/60 dark:text-amber-300">
          <AlertTriangleIcon size={18} />
        </span>
        <div>
          <h3 className="text-sm font-extrabold text-amber-900 dark:text-amber-200">
            {t('connect.banner.expiringTitle')}
          </h3>
          <p className="mt-0.5 text-xs text-amber-800/90 dark:text-amber-300/80">
            {t('connect.banner.expiringBody').replace('{count}', String(expiringCount))}
          </p>
        </div>
      </div>
      <div className="flex items-center gap-2 self-end sm:self-center">
        <Button
          type="button"
          size="sm"
          variant="secondary"
          onClick={onReconnect}
          className="border-warning-300 bg-white text-warning-900 hover:bg-warning-100 dark:border-amber-800 dark:bg-amber-950 dark:text-amber-200 dark:hover:bg-amber-900"
        >
          {t('connect.banner.reconnect')}
        </Button>
      </div>
    </div>
  );
}

export default TokenExpiryBanner;
